import { youtubeFormatUrl } from './youtube-format-url';

export const createYoutubeIframe = (url: string): string => {
  const src = youtubeFormatUrl(url);
  return `<iframe style="border-radius:8px;" width="100%" height="315" src="${src}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
};
